(function() {
	'use strict';

	angular.module('quantixApp').factory('localStorage', localStorage);
	localStorage.$inject = [ '$resource' ];
	function localStorage($resource) {
		return {};
	}

	angular.module('quantixApp').controller('renewableEnergyController',
			renewableEnergyController)
	renewableEnergyController.$inject = [ '$scope', 'Principal', '$state','InfrastructureProjectsService',
			'renewableEnergyService', 'GenericService', 'GenericServiceNew',
			'ivhTreeviewBfs', '$timeout', 'ivhTreeviewOptions',
			'ErrorHandlerService', '$uibModal', '$http', '$stateParams',
			'$rootScope', '$anchorScroll', '$window', '$filter' ];

	function renewableEnergyController($scope, Principal, $state, InfrastructureProjectsService,
			renewableEnergyService, GenericService, GenericServiceNew,
			ivhTreeviewBfs, $timeout, ivhTreeviewOptions, ErrorHandlerService,
			$uibModal, $http, $stateParams, $rootScope, $anchorScroll, $window, $filter) {
		$scope.totalObj = new Object();
		$scope.tenderObj = new Object();
		$scope.sectorObj = $rootScope.sectorObj;
		$scope.tenderObj.minMaxSchemeCapacity;
		$scope.sectorList = [];
		$scope.fuelMaster = [];
		$scope.projectAllocationMaster = [];
		$scope.issuerList = [];
		$scope.sectorName = 'RE';
		$scope.schemeLocationList = [
			{'id' : '0', 'locationName' : 'All'},
			{'id' : '1', 'locationName' : 'State name'},
			{'id' : '2', 'locationName' : 'Anywhere in India'},
			{'id' : '3', 'locationName' : 'Not specified'}
		];
		$scope.tenderObj.schemeLocationVal;
		$scope.tenderObj.psaCounterParty=[];
		$scope.projectAllocationMasterVal = "";
		$scope.fuelSelctionVal;
		$scope.issuerSelctionVal;
		$scope.minSchemeCapacity;
		$scope.maxSchemeCapacity;
		$scope.sliderSchemeCapacity;
		$scope.sliderAllocatedCapacity;
		$scope.sliderBidTariff;
		$scope.totalObj.ppaCounterpartyList = [];
		$scope.tenderObj.ppaCounterpartyVal = [];
		$scope.projectStatus = new Object;
		$scope.projectStatus.statusList;
		$scope.allocationOfTender = new Object();
		$scope.allocationOfTender.fromDate = new Date();
		$scope.allocationOfTender.toDate = new Date();
		$scope.allocationOfTender.monthOfAllocation = [];
		
		$scope.commercialOpDate = new Object();
		$scope.commercialOpDate.fromDate = new Date();
		$scope.commercialOpDate.toDate = new Date();
		$scope.commercialOpDate.commercialOpDate = [];
			
		$scope.misReport = new Object();
		$scope.misReport.fromDate = new Date();
		$scope.misReport.toDate = new Date();
		$scope.misReport.releaseTender = [];
		$scope.startMaxDate = new Date();
		$scope.endMaxDate = new Date();
		$scope.alreadySearch = '';
		$scope.validateSearch = '';
		$scope.popup1 = {
			opened : false
		};
		$scope.popup2 = {
			opened : false
		};

		$scope.open1 = function($event) {
			$scope.popup1.opened = true;
		};
		$scope.open2 = function($event) {
			$scope.popup2.opened = true;
		};

		$scope.popup3 = {
			opened : false
		};
		$scope.popup4 = {
			opened : false
		};

		$scope.open3 = function($event) {
			$scope.popup3.opened = true;
		};
		$scope.open4 = function($event) {
			$scope.popup4.opened = true;
		};

		$scope.dateOptions = {
			formatYear : 'yy',
			startingDay : 1
			
		};

		$scope.modeOfAwardList = [];
		$scope.awardingAuthorityList = [];
		$scope.projectStatusList = [];
		$scope.projectCostList = [];
		$scope.slider;
		$scope.minsize;
		$scope.maxsize;
		$scope.listofobj = [];
		$scope.listofpromoterorparent = [];
		$scope.searchcomp = ' ';
		$scope.searchpromoterparent = ' ';
		$scope.searcharrcmp = [];
		$scope.searcharrpro = [];
		$scope.selectedLocations = [];
		$scope.selectedFilterIdToLoad = null;
		$scope.selectedFilterJsonToLoad = null;
		$scope.arrow = ">";
		$scope.status = {
			isCustomHeaderOpen : false,
			isFirstOpen : true,
			isFirstDisabled : false
		};
		$scope.errorExport = false

		$scope.fromDate = new Date();
		$scope.toDate = new Date();

		$scope.awardingDateFromModel = '';
		$scope.awardingDateToModel = '';
		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy',
				'shortDate', 'dd-MMM-yyyy', 'MMM-yyyy' ];
		$scope.format = $scope.formats[5];
		$scope.formatM = $scope.formats[0];
		$scope.requiredFormat = $scope.formats[4];
		var gridData = '';
		var gridData2 = '';
		$scope.exportFlag = false;
		$scope.gridDataForBotToll = {
			dataProvider: [],
			delegate: $scope
		}
		$scope.gridDataForAllocation = {
			dataProvider: [],
			delegate: $scope
		}
		$scope.modal = {
				selectedHolding: "",
				selectedSpv : ""
		}
		$scope.userSectionAccessData = GenericService.getUserSectionAccessData();

		GenericService.getUserModuleAccessData().then(function(result) {
			GenericService.getUserSectionAccessData().then(function (result) {
                $scope.userSectionAccessData = result;
				if (!(($scope.userSectionAccessData["INFRASTRUCTURE.Renewables"] == "Y") || ($scope.userSectionAccessData["INFRASTRUCTURE.Renewables_Trial"] == "Y"))) {
					ErrorHandlerService.forbiddenError("Renewable Energy");
					return;
				}
				if ($scope.userSectionAccessData["INFRASTRUCTURE.Renewables"] == "Y") {
					$scope.exportFlag = true;
				}
            });
			if (!result["INFRASTRUCTURE"]) {
				ErrorHandlerService.forbiddenError("INFRASTRUCTURE");
				return;
			}
		});
		$scope.getDate = function(rowData,column) {
			var param = column.dataField;
			var val = rowData[param];
			var re = new RegExp("^[a-zA-Z ]+$");
			if(val!=null && !re.test(val)) {
				var arr = val.split("-");
				val = arr[1]+"-"+arr[2];
			}
			return val;
		}
		$scope.setHeaderText = function(rowData, column) {
			var plfYearObject = {
				'plfValue1': 'fiscalYear1',
				'plfValue2': 'fiscalYear2',
				'plfValue3': 'fiscalYear3',
			};
			var param = column.dataField;
			var headerVal = rowData[plfYearObject[param]];
			// headerVal = headerVal.toString().replace("20","FY");
			column._headerText = "PLF "+headerVal;
			var val = rowData[param];
			return val;
		}

		$scope.StartUp = function() {
			renewableEnergyService.getPpaCounterpartyList().then(function(successData) {
				$scope.totalObj.ppaCounterpartyList = successData;
				$scope.init();
			}, function(errordata) {
				$scope.init();
			});
		}
		
		
		$scope.init = function() {
			
			renewableEnergyService.getProjectAllocationList().then(function(data) {
				$scope.projectAllocationMaster = data;
				if(data.length > 0 && data[0] != '' && data[0] != undefined) {
					$scope.projectAllocationMasterVal = data[0];
					$scope.allocationMasterChange();
				}
				
			}, function(errordata) {

			});

			renewableEnergyService.getFuelMaster().then(function(data) {
				$scope.fuelMaster = data;
			}, function(errordata) {

			});
			
			renewableEnergyService.getStateNameList().then(function(data) {
				$scope.totalObj["stateMaster"] = data;
				// var psaCounterPartyList = [];
				// psaCounterPartyList.push.apply(psaCounterPartyList,data);
				// psaCounterPartyList.splice(psaCounterPartyList.findIndex(function(el) {return el.stateName.trim() == 'Anywhere in India';}),1);
				// psaCounterPartyList.splice(psaCounterPartyList.findIndex(function(el) {return el.stateName.trim() == 'Not specified';}),1);
				// psaCounterPartyList.splice(psaCounterPartyList.findIndex(function(el) {return el.stateName.trim() == 'Not available';}),1);
				// $scope.totalObj["psaCounterParty"] = psaCounterPartyList;
			}, function(errordata) {
			});

			renewableEnergyService.getUniquePsaCounterParty().then(function(data) {
				var psaCounterPartyList = [];
				// if(data != undefined || data != '' || data != null) {
				// 	data.forEach((val, index) => {
				// 		var obj = {id: index, value: val};
				// 		psaCounterPartyList.push(obj);
				// 	});
				// }
				psaCounterPartyList.push.apply(psaCounterPartyList,data);
				$scope.totalObj["psaCounterParty"] = psaCounterPartyList;
			}, function(errordata) {
			});
			
			renewableEnergyService.getIssuerList().then(function(data) {
				$scope.issuerList = data;
			}, function(errordata) {

			});
			
			renewableEnergyService.getMinMaxSchemeCapacity().then(function(data) {
				$scope.tenderObj.minMaxSchemeCapacity = data;
				$scope.sliderSchemeCapacity = {
					minValue : data[0],
					maxValue : data[1],
					options : {
						floor : data[0],
						ceil : data[1],
						step : 1
					}
				};
			}, function(errordata) {

			});

			renewableEnergyService.getProjectStatus().then(function(data) {
				$scope.projectStatusList = data;
			}, function(errordata) {

			});

			renewableEnergyService.getCapacityAllocatedMw().then(function(data) {
				$scope.sliderAllocatedCapacity = {
					minValue : data[0],
					maxValue : data[1],
					options : {
						floor : data[0],
						ceil : data[1],
						step : 1
					}
				};
			}, function(errordata) {

			});
			
			renewableEnergyService.getMinMaxBidTariff().then(function(data) {
				$scope.sliderBidTariff = {
					minValue : data[0],
					maxValue : data[1],
					options : {
						floor : data[0],
						ceil : data[1],
						step : 1
					}
				};
			}, function(errordata) {

			});
			
			renewableEnergyService.getDistinctMonthOfAllocation().then(function(data) {
				var  monthAllowArr = [];
				angular.forEach(data, function(value, i) {
					var monthAllowObj = new Object();
				    monthAllowObj.id = i;
				    monthAllowObj.val = value;
				    monthAllowArr.push(monthAllowObj);
				});
				$scope.totalObj["distincMonthOfAllocation"] = monthAllowArr;
			});
			renewableEnergyService.getDistinctMonthOfReleaseTender().then(function(data) {
				var  monthAllowArr = [];
				angular.forEach(data, function(value, i) {
					var monthAllowObj = new Object();
				    monthAllowObj.id = i;
				    monthAllowObj.val = value;
				    monthAllowArr.push(monthAllowObj);
				});
				$scope.totalObj["distincMonthOfReleaseTender"] = monthAllowArr;
			});
			renewableEnergyService.getDistinctCommercialOpDate().then(function(data) {
				var  monthAllowArr = [];
				angular.forEach(data, function(value, i) {
					var monthAllowObj = new Object();
				    monthAllowObj.id = i;
				    monthAllowObj.val = value;
				    monthAllowArr.push(monthAllowObj);
				});
				$scope.totalObj["distincCommercialOpDate"] = monthAllowArr;
			});
			
			$timeout(
					function() {
						if($scope.selectedFilterJsonToLoad) {
							$scope.loadFilterForSelectedId();
							$scope.displayData();
						}
				}, 2000);
		}

		
		$scope.allocationMasterChange = function() {
			$("#selectionShowId").hide();
			$("#selectionShowForNoData").hide();
			$scope.projectDataMap = [];
			$scope.resetFilter();
			
			renewableEnergyService.getDistinctMonthOfAllocation().then(function(data) {
				var  monthAllowArr = [];
				angular.forEach(data, function(value, i) {
					var monthAllowObj = new Object();
				    monthAllowObj.id = i;
				    monthAllowObj.val = value;
				    if($scope.projectAllocationMasterVal['id'] == 2 && value == 'Not allocated') {
				    } else {
				    	monthAllowArr.push(monthAllowObj);
				    }
				});
				$scope.totalObj["distincMonthOfAllocation"] = monthAllowArr;
			});
			
			
		}
				
		// code added later
		$scope.projectDataMap;
		$scope.projectAllocationDataMap;
		$scope.displayData = function() {
			$scope.projectDataMap = [];
			$scope.selectedFilter = $scope.createFilterJson();
			$rootScope.selectedFilterForInfa = $scope.selectedFilter;
			renewableEnergyService.getProjectDataMapForSelection(
					$scope.selectedFilter).then(function(data) {
						if(Object.entries(data).length > 0) {
							$("#selectionShowId").show();
							$("#selectionShowForNoData").hide();
							$scope.projectDataMap = data;
							$("#ReBtnId a.downloadexcel_link").removeClass("disable-section");
							if($scope.projectAllocationMasterVal['id'] == 2) {
								$("#ReBtnId div.radio-inline input").removeClass("disabled");
							}
						} else {
							$("#selectionShowId").hide();
							$("#selectionShowForNoData").show();
							$("#ReBtnId a.downloadexcel_link").addClass("disable-section");
							$("#ReBtnId div.radio-inline input").removeClass("disabled");
						}
						
			}, function(errordata) {

			});
		}

		// show

		$scope.showData = function(dtoValue) {
			$scope.currentModelData = $scope.projectDataMap[dtoValue];
			if($scope.projectAllocationMasterVal['id'] == 1) {
				$(".tenderCls").show();
				$(".allocationCls").hide();
				// $scope.gridDataForBotToll = {
				// 	dataProvider : $scope.currentModelData.slice(0, 10),
				// 	delegate : $scope
				// };
				
				if(gridData) {
					gridData.setDataProvider($scope.currentModelData.slice(0, 10));
					gridData.creationComplete(gridData, true);
				}
			} else {
				$(".tenderCls").hide();
				$(".allocationCls").show();
				// $scope.gridDataForAllocation = {
					// 	dataProvider : $scope.currentModelData.slice(0, 10),
					// 	delegate : $scope
					// };
					if(gridData2) {
						gridData2.setDataProvider($scope.currentModelData.slice(0, 10));
						gridData2.creationComplete(gridData2);
						
					}
				}
			
		}

		$scope.botTollListGridCompletion = function(event) {
			gridData = event.target;
			gridData.validateNow();
			$("#gridForBotToll_btnSettings img").attr('title','Select columns');
			
		};
		$scope.botTollListGridCompletion2 = function(event) {
			gridData2 = event.target;
			gridData2.validateNow();
			$("#gridForBotToll2_btnSettings img").attr('title','Select columns');
		};

		$scope.showMoreData = function() {
			renewableEnergyService.viewRenewabledata(
				$scope.selectedFilter).then(function (data) {
					

				}, function (errordata) {

				});
			$state.go('infraREDetails', {
				'data' : $scope.currentModelData,
				'modelName' : $scope.modelNameKey,
				'selectedFilter' : $scope.selectedFilter
			});

		}

		$scope.saveIPFilterInDb = function(filterName) {
			if (filterName != null && filterName != "") {
				var fd = new FormData();
				var url = 'api/infrastructureProjects/saveUserIpFilter';
				fd.append('data', $scope.selectedFilter);
				fd.append('filterName', filterName);
				fd.append('sector',$scope.sectorName)
				$http.post(url, fd, {
					transformRequest : angular.identity,
					headers : {
						'Content-Type' : undefined
					}
				}).success(function(response) {
					$scope.success = 'OK';
					$timeout(function() {
						$scope.success = '';
					}, 10000);
					$scope.cancel();
					$scope.alreadySearch = null;
					$scope.showSuccessMessages("Filter saved successfully");
				}).error(function(response) {
					$scope.validateSearch = '';
					$scope.alreadySearch = "Filter Name Already Exists.";
				});
			} else {
				$scope.alreadySearch = '';
				$scope.validateSearch = "Filter Name is Required.";
			}
		}

		$scope.saveFilter = function() {
			if ($scope.validateFilters()) {
				$scope.selectedFilter = $scope.createFilterJson();

				var modal = $uibModal.open({
					templateUrl : 'infrastructureProjects-dialog.html',
					scope : $scope
				})

				$scope.modalInstance = modal;

				$scope.cancel = function() {
					$scope.modalInstance.dismiss('cancel');
				}
			}
		}

		var alertMessages = [];
		$scope.validateFilters = function() {

			return true;
		}

		$scope.showErrorMessages = function(messageContent) {
			$scope.iferror = true;
			$scope.errorMessages = messageContent;

			$timeout(function() {
				$scope.iferror = false;
				$scope.errorMessages = "";
			}, 3000);
			
			$scope.closeErrorMsg = function() {
				$scope.iferror = false;
			}
		}

		$scope.showSuccessMessages = function(messageContent) {
			$scope.ifsuccess = true;
			$scope.successMessages = messageContent;

			$timeout(function() {
				$scope.ifsuccess = false;
				$scope.successMessages = "";
			}, 3000);
		}

		
		var searchText = '';
		$scope.isFinancial = false;
		$scope.createFilterJson = function() {
			var isInValid = false;
			var error = "";
			searchText = new Object();
			//searchText['default'] = 'none';
			/**Vijay code Start*/
			
			if($("#ReBtnId input[type='radio']:checked").length > 0) {
				$scope.isFinancial = true;
				searchText['addFinancial'] = $("#ReBtnId input[type='radio']:checked").val();
			}
			if($scope.projectAllocationMasterVal != null && $scope.projectAllocationMasterVal != undefined) {
				searchText['allocationId'] = $scope.projectAllocationMasterVal['id'];
			}
			if($scope.fuelSelctionVal != null && $scope.fuelSelctionVal != undefined && $scope.fuelSelctionVal.length > 0) {
				searchText['fuelIds'] = $scope.fuelSelctionVal.map(function(ele) {
				    return ele.id;
				}).join(",");
			}
			
			if($scope.issuerSelctionVal != null && $scope.issuerSelctionVal != undefined && $scope.issuerSelctionVal.length > 0) {
				searchText['issuerIds'] = $scope.issuerSelctionVal.map(function(ele) {
				    return ele.id;
				}).join(",");
			}
			if($scope.tenderObj.psaCounterParty != null && $scope.tenderObj.psaCounterParty != undefined && $scope.tenderObj.psaCounterParty.length>0) {
				searchText['psaCounterParty'] =  $scope.tenderObj.psaCounterParty.map(function(ele) {
				    return ele.stateName;
				});
			}  else {
				isInValid = false;;
				error = "Please select psa counter party";
			}
			
			if($scope.allocationOfTender != null && $scope.allocationOfTender != undefined) {
				if(moment($scope.allocationOfTender.fromDate).format("MMM-YYYY") != moment($scope.allocationOfTender.toDate).format("MMM-YYYY")) {
					searchText['allocationOfTenderFromDate'] = $scope.allocationOfTender.fromDate;
					searchText['allocationOfTenderToDate'] = $scope.allocationOfTender.toDate;
				}
				if($scope.allocationOfTender.monthOfAllocation.length > 0) {
					searchText['monthOfAllocationExtra'] = $scope.allocationOfTender.monthOfAllocation.map(function(ele) {
					    return ele.val;
					});
				}
			}
			if(searchText['allocationId'] == "1") {
				if($scope.sliderSchemeCapacity != null && $scope.sliderSchemeCapacity != undefined) {
					searchText['schemeCapacityMinValue'] = $scope.sliderSchemeCapacity['minValue'];
					searchText['schemeCapacityMaxValue'] = $scope.sliderSchemeCapacity['maxValue'];
				}
				
				if($scope.misReport != null && $scope.misReport != undefined) {
					if(moment($scope.misReport.fromDate).format("MMM-YYYY") != moment($scope.misReport.toDate).format("MMM-YYYY")) {
						searchText['releaeTenderFromdate'] = $scope.misReport.fromDate;
						searchText['releaeTenderTodate'] = $scope.misReport.toDate;
					}
					if($scope.misReport.releaseTender.length>0) {
						searchText['releaseTenderExtra'] = $scope.misReport.releaseTender.map(function(ele) {
						    return ele.val;
						});;
					}
				}
				if($scope.tenderObj.schemeLocationVal != null && $scope.tenderObj.schemeLocationVal != undefined && $scope.tenderObj.schemeLocationVal.length > 0) {
					searchText['schemeLocation'] =  $scope.tenderObj.schemeLocationVal.map(function(ele) {
					    return ele.stateName;
					}).join(",");
				} else {
					isInValid = false;
				}
			} else {
				if($scope.sliderAllocatedCapacity != null && $scope.sliderAllocatedCapacity != undefined) {
					searchText['allocatedCapacityMinValue'] = $scope.sliderAllocatedCapacity.minValue;
					searchText['allocatedCapacityMaxValue'] = $scope.sliderAllocatedCapacity.maxValue;
				}
				
				if($scope.commercialOpDate != null && $scope.commercialOpDate != undefined) {
					if(moment($scope.commercialOpDate.fromDate).format("MMM-YYYY") != moment($scope.commercialOpDate.toDate).format("MMM-YYYY")) {
						searchText['commercialOpDateFromDate'] = $scope.commercialOpDate.fromDate;
						searchText['commercialOpDateToDate'] = $scope.commercialOpDate.toDate;
					}
					if($scope.commercialOpDate.commercialOpDate.length > 0) {
						searchText['commercialOpDateExtra']= $scope.commercialOpDate.commercialOpDate.map(function(ele) {
						    return ele.val;
						});
					}
				}
				
				if($scope.sliderBidTariff != null && $scope.sliderBidTariff != undefined) {
					searchText['sliderBidTariffMinValue'] = $scope.sliderBidTariff.minValue;
					searchText['sliderBidTariffMaxValue'] = $scope.sliderBidTariff.maxValue;
				}
				if($scope.projectStatus.statusList != null && $scope.projectStatus.statusList != undefined && $scope.projectStatus.statusList.length > 0) {
					searchText['projectStatusIds'] = $scope.projectStatus.statusList.map(function(ele) {
					    return ele.id;
					}).join(",");
				}
			}
			
			if($scope.tenderObj.ppaCounterpartyVal != null && $scope.tenderObj.ppaCounterpartyVal != undefined && $scope.tenderObj.ppaCounterpartyVal.length > 0) {
				searchText['ppaCounterparty'] =  $scope.tenderObj.ppaCounterpartyVal.map(function(ele) {
				    return ele.ppaCounterpartyName;
				}).join(",");
			}
			if($scope.sectorObj != null && $scope.sectorObj != undefined) {
				searchText['sectorId'] = $scope.sectorObj["sectorId"]
			}
			/**Vijay Code End*/
			if(isInValid) {
				$scope.showErrorMessages(error);
			} else {
				return JSON.stringify(searchText).replace(/\'/g, "\"").replace(/\</g, "\'");
			}
		}

		

		$scope.removeShowErrorMessages = function(messageContent) {
			$scope.removeError = true;
			$scope.removeErrorMessages = messageContent;

			$timeout(function() {
				$scope.removeError = false;
				$scope.removeErrorMessages = "";
			}, 10000);
		}

		$scope.removeShowSuccessMessages = function(messageContent) {
			$scope.removeSuccess = true;
			$scope.removeSuccessMessages = messageContent;

			$timeout(function() {
				$scope.removeSuccess = false;
				$scope.removeSuccessMessages = "";
			}, 3000);
		}

		var vm = this;
		vm.selectedirsIndustry = [];
		$scope.sectorModel = [];
		$scope.projectStatusModel = [];
		$scope.modeOfAwardModel = [];

		$scope.loadFilter = function() {
			InfrastructureProjectsService.getUserSavedFilterList($scope.sectorName).then(function(data) {
				$scope.userSavedFilterList = angular.fromJson(data);				
			}, function(errordata) {
				
			});
			$("#loadFiltermodalId").modal('show');
		}

		$scope.setLoadId = function (id, filterJson){
			$scope.selectedFilterIdToLoad =id;
			$scope.selectedFilterJsonToLoad =filterJson;
		}

		var sectorArr;
		var stateArr;
		var modeOfAwardArr;
		var projectStatusArr;
		var awardingAuthorityArr;
		var projectCostArr;
		var companyArr;
		var promoterArr;

		$scope.loadFilterForSelectedId = function() {
			if ($scope.selectedFilterIdToLoad == null
					|| $scope.selectedFilterIdToLoad == '') {
				$scope.removeShowErrorMessages("Please select filter to load.");
				return false;
			}

			var obj = JSON.parse($scope.selectedFilterJsonToLoad);
			if(obj.hasOwnProperty('sectorId')) {
				$scope.sectorObj["sectorId"] = obj.sectorId;
			}
			$timeout(
				function() {
					if(obj.hasOwnProperty('allocationId')) {
						if($scope.projectAllocationMasterVal.id != obj.allocationId) {
								$("multiselect#projectAllocationId ul#dropdownscroll li#2 a i").trigger("click");
						}
					}
					$scope.loadFilters(obj);
				}, 2000);
			$scope.selectedFilterJsonToLoad = null;
		}
		
		$scope.loadFilters = function(obj) {

			if(obj.hasOwnProperty('fuelIds')) {
				$scope.fuelSelctionVal = $scope.fuelMaster.filter(function(e){
					return obj.fuelIds.includes(e.id);
					});
			}
			if(obj.hasOwnProperty('issuerIds')) {
				// $scope.issuerSelctionVal = angular.element(function(e){
				// 	return obj.issuerIds.includes(e.id);
				// 	});
				$scope.issuerSelctionVal = $scope.issuerList.filter(function(e){
					return obj.issuerIds.includes(e.id);
					});
			}
			if(obj.allocationId == 1) {
				if(obj.hasOwnProperty('schemeCapacityMaxValue')) {
					$scope.sliderSchemeCapacity.maxValue = obj.schemeCapacityMaxValue;
				}
				
				if(obj.hasOwnProperty('schemeCapacityMinValue')) {
					$scope.sliderSchemeCapacity.minValue = obj.schemeCapacityMinValue;
				}
				
				if(obj.hasOwnProperty('releaeTenderFromdate')) {
					$scope.misReport.fromDate = new Date(obj.releaeTenderFromdate);
				}
				
				if(obj.hasOwnProperty('releaeTenderTodate')) {
					$scope.misReport.toDate = new Date(obj.releaeTenderTodate);
				}
				
				if(obj.hasOwnProperty('releaseTenderExtra')) {
					$scope.misReport.releaseTender = $scope.totalObj.distincMonthOfReleaseTender.filter(function(e) {
						return obj.releaseTenderExtra.includes(e.val);
					});
				}
				
				if(obj.hasOwnProperty('schemeLocation')) {
					const locArr =obj.schemeLocation.split(",");
					$scope.tenderObj.schemeLocationVal = $scope.totalObj['stateMaster'].filter(function(e) {
						return locArr.includes(e.stateName);
					});
				}
				
			} else {
				if(obj.hasOwnProperty('allocatedCapacityMinValue')) {
					$scope.sliderAllocatedCapacity.minValue = obj.allocatedCapacityMinValue;
				}
				if(obj.hasOwnProperty('allocatedCapacityMaxValue')) {
					$scope.sliderAllocatedCapacity.maxValue = obj.allocatedCapacityMaxValue;
				}
				if(obj.hasOwnProperty('sliderBidTariffMinValue')) {
					$scope.sliderBidTariff.minValue = obj.sliderBidTariffMinValue;
				}
				if(obj.hasOwnProperty('sliderBidTariffMaxValue')) {
					$scope.sliderBidTariff.maxValue = obj.sliderBidTariffMaxValue;
				}
				if(obj.hasOwnProperty('commercialOpDateFromDate')) {
					$scope.commercialOpDate.fromDate = new Date(obj.commercialOpDateFromDate);
				}
				if(obj.hasOwnProperty('commercialOpDateToDate')) {
					$scope.commercialOpDate.toDate = new Date(obj.commercialOpDateToDate);
				}
				if(obj.hasOwnProperty('commercialOpDateExtra')) {
					$scope.commercialOpDate.commercialOpDate = $scope.totalObj.distincCommercialOpDate.filter(function(e) {
						return obj.commercialOpDateExtra.includes(e.val);
					});
				}
				if(obj.hasOwnProperty('projectStatusIds')) {
					const statusIdArr = obj.projectStatusIds.split(',');
					$scope.projectStatus.statusList = $scope.projectStatusList.filter(function(e) {
						return statusIdArr.includes(e.id.toString());
					});
				}
			}
			
			if(obj.hasOwnProperty('allocationOfTenderFromDate')) {
				$scope.allocationOfTender.fromDate = new Date(obj.allocationOfTenderFromDate);
			}
			if(obj.hasOwnProperty('allocationOfTenderToDate')) {
				$scope.allocationOfTender.toDate = new Date(obj.allocationOfTenderToDate);
			}
			if(obj.hasOwnProperty('monthOfAllocationExtra')) {
				$scope.allocationOfTender.monthOfAllocation = $scope.totalObj.distincMonthOfAllocation.filter(function(e) {
					return obj.monthOfAllocationExtra.includes(e.val);
				});
			}
			
			if(obj.hasOwnProperty('ppaCounterparty')) {
				const ppaArr = obj.ppaCounterparty.split(",")
				$scope.tenderObj.ppaCounterpartyVal = $scope.totalObj.ppaCounterpartyList.filter(function(e) {
					return ppaArr.includes(e.ppaCounterpartyName);
				});
			}
			if(obj.hasOwnProperty('psaCounterParty')) {
				$scope.tenderObj.psaCounterParty = $scope.totalObj['psaCounterParty'].filter(function(e) {
					return obj.psaCounterParty.includes(e.stateName);
				});
			}
			$("#loadFiltermodalId").modal('hide');
		}
		

		$scope.resetFilter = function() {
			$scope.tenderObj.schemeLocationVal = [];
			$scope.tenderObj.ppaCounterpartyVal = [];
			$scope.tenderObj.psaCounterParty = [];
			$scope.fuelSelctionVal = [];
			$scope.issuerSelctionVal = [];
			$scope.misReport.fromDate = new Date();
			$scope.misReport.toDate = new Date();
			$scope.misReport.releaseTender = [];
			$scope.allocationOfTender.fromDate = new Date();
			$scope.allocationOfTender.toDate = new Date();
			$scope.allocationOfTender.monthOfAllocation = [];
			$scope.commercialOpDate.fromDate = new Date();
			$scope.commercialOpDate.toDate = new Date();
			$scope.commercialOpDate.commercialOpDate = [];
			$scope.projectStatus.statusList = [];
			$scope.selectedFilter = undefined;
			$scope.projectDataMap = [];
			if($scope.projectAllocationMasterVal['id'] == 1) {
				$scope.sliderSchemeCapacity.minValue = $scope.sliderSchemeCapacity.options.floor;
				$scope.sliderSchemeCapacity.maxValue = $scope.sliderSchemeCapacity.options.ceil;
			} else {
				$scope.sliderAllocatedCapacity.minValue = $scope.sliderAllocatedCapacity.options.floor;
				$scope.sliderAllocatedCapacity.maxValue = $scope.sliderAllocatedCapacity.options.ceil;
				$scope.sliderBidTariff.minValue = $scope.sliderBidTariff.options.floor;
				$scope.sliderBidTariff.maxValue = $scope.sliderBidTariff.options.ceil;
			}
			
			$("#selectionShowId").hide();
			$("#selectionShowForNoData").hide();
			$("#ReBtnId a.downloadexcel_link").addClass("disable-section");
		}

		// Export excel code added

		$scope.downloadDataInExcel = function() {
			$scope.selectedFilter = $scope.createFilterJson();
			var json = JSON.parse($scope.selectedFilter);
			json['downloadFlag'] = true;
			$scope.selectedFilter = JSON.stringify(json);
			if ($scope.selectedFilter != undefined) {
				$http({
					url : 'api/infrastructureProjects/exportExcelRenewableData',
					method : 'POST',
					data : JSON.parse($scope.selectedFilter),
					responseType : 'arraybuffer'
				})
						.success(

								function(response) {
									if (response.byteLength > 0) {
										var isIE = false || !!document.documentMode;
										$scope.response = response;
										var blob = new Blob(
												[ response ],
												{
													type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
												});
										if (isIE) {

											window.navigator
													.msSaveOrOpenBlob(blob,
															'Infrastructure Project Report_New.xlsx');
										} else {

											var anchor = angular
													.element('<a/>');
											var blob = new Blob(
													[ response ],
													{
														type : 'application/vnd.ms-excel'
													})
											var objectUrl = (window.URL || window.webkitURL)
													.createObjectURL(blob);
											anchor.css({
												display : 'none'
											});
											// Make sure it's not visible
											angular.element(document.body)
													.append(anchor); // Attach
																		// to
											// document
											anchor
													.attr({
														href : objectUrl,
														target : '_self',

														download : 'Infrastructure Project Report.xlsx'
													})[0].click();

											anchor.remove();

										}
									} else {
										$scope.showErrorMessages("Data not Found");
									}
								})

			} else {
				alert("Please click on Display Data before Exporting Data  ");
			}

		}

		// Date Validation
		$scope.checkErr = function(fromDate, toDate) {
			$scope.errMessage = '';
			$scope.fromDateTrue = false;
			$scope.toDateTrue = false;

			var curDate = new Date();
			if ((fromDate != '' && toDate != '')
					&& (fromDate != undefined && toDate != undefined)) {
				var errorMsg = "";
				
				if (new Date(fromDate) > new Date(toDate)) {
					$scope.toDateTrue = false;
					errorMsg = "To Date should be greater than From Date.";
				} else {
					$scope.toDateTrue = true;
				}
				if (new Date(fromDate) < curDate) {
					$scope.fromDateTrue = true;
				} else {
					$scope.fromDateTrue = false;
					$scope.errMessage = 'fromDate should not be before today.';
					alert("From Date should not be before Today.");
					return false;
				}
			} else {
				$scope.fromDateTrue = true;
				$scope.toDateTrue = true;
			}
		};

		$scope.removeIpFilterFromDb = function (id, index){
			InfrastructureProjectsService.deleteUserFilterById(id).then(function(data) {
				if(data == true){
					$scope.userSavedFilterList.splice(index, 1);
					$scope.removeShowSuccessMessages("Filter deleted successfully.");
				} else{
					$scope.removeShowErrorMessages("Filter not deleted.");
				}				
			}, function(errordata) {
				$scope.removeShowErrorMessages("Error while deleting filter.");
			});
		}

		$scope.closeErrorMsg = function() {
			$scope.iferror = false;
		}
		
		if ($rootScope.selectedFilterForInfa != null
				&& $rootScope.selectedFilterForInfa != undefined) {
			$scope.selectedFilterIdToLoad = '1';
			$scope.selectedFilterJsonToLoad = $rootScope.selectedFilterForInfa;
			$rootScope.selectedFilterForInfa = null;
		}
		
		$scope.StartUp();

	}
})();
